import { Component, OnDestroy } from '@angular/core'
import { MbCheckoutConfirmationBaseComponent } from '../mb-checkout-confirmation-base.component'
import { Router } from '@angular/router'
import { MbOrderService } from '../../../services/mb-order.service'
import { MbCheckoutRegions } from '../../../../models'
import { OrderHistoryService } from '@spartacus/order/core'

@Component({
  selector: 'mb-checkout-confirmation-eu',
  templateUrl: './mb-checkout-confirmation-eu.component.html',
  styleUrls: ['../mb-checkout-confirmation-base.component.scss']
})
export class MbCheckoutConfirmationEuComponent extends MbCheckoutConfirmationBaseComponent implements OnDestroy {

  checkoutRegion = MbCheckoutRegions.EU

  constructor (protected orderService: OrderHistoryService,
               protected mbCheckoutService: MbOrderService,
               protected router: Router) {
    super(orderService, router)
  }

  ngOnDestroy () {
    this.mbCheckoutService.stopPlaceOrderTrigger()
  }
}
